import { QuestionnaireComponentKind } from '@main/dynamic-form';
import { Vendor_Questionnaire_Form_Answer_Statuses_Enum } from '@main/graphql/types.generated';
import { useMemo } from 'react';

import { flattenFields } from '../utils';
import { QuestionnaireFormContextValue, useQuestionnnaireFormContext } from './context';
import { QuestionnaireFormFieldConfig, QuestionnnaireFormStats } from './form-types';
import { useVisibleFieldsEx } from './use-visible-fields';

export function useQuestionnaireFormStats(
  fields: readonly QuestionnaireFormFieldConfig[],
  context?: QuestionnaireFormContextValue,
): QuestionnnaireFormStats {
  const { answersMap } = useQuestionnnaireFormContext(context);
  const { getFilteredFieldsRecursive } = useVisibleFieldsEx(context);
  const filteredFields = useMemo(
    () => flattenFields(getFilteredFieldsRecursive(fields)),
    [fields, getFilteredFieldsRecursive],
  );

  const total = useMemo(
    () => filteredFields.filter((f) => f.kind !== QuestionnaireComponentKind.Section),
    [filteredFields],
  );
  const completed = useMemo(
    () =>
      total.filter(
        (f) =>
          answersMap.get(f.name)?.status ===
          Vendor_Questionnaire_Form_Answer_Statuses_Enum.Completed,
      ),
    [answersMap, total],
  );

  return useMemo(() => ({ total: total.length, completed: completed.length }), [total, completed]);
}
